import { memo, useEffect } from '../../lib/teact/teact';
import { withGlobal } from '../../global';

import { selectRasiTechModules } from '../../global/selectors/sharedState';
import { getPrivateModeSettings } from '../../util/modModules';

import '../../styles/rasitech-mod.scss';

type StateProps = {
  privateMode: ReturnType<typeof getPrivateModeSettings>;
  customBackgroundUrl: string;
};

const BODY = typeof document !== 'undefined' ? document.body : undefined;

const RasiTechEffects = ({ privateMode, customBackgroundUrl }: StateProps) => {
  useEffect(() => {
    if (!BODY) return undefined;

    const classes: string[] = [];
    if (privateMode.blurContactNames) classes.push('rasi-blur-names');
    if (privateMode.blurContactPhotos) classes.push('rasi-blur-photos');
    if (privateMode.blurLastMessage) classes.push('rasi-blur-last-message');
    if (privateMode.blurChatContent) classes.push('rasi-blur-chat-content');
    if (privateMode.hideOnlineStatus) classes.push('rasi-hide-online');
    if (privateMode.disableReadReceipt) classes.push('rasi-hide-read-receipts');
    if (privateMode.hideTyping) classes.push('rasi-hide-typing');
    if (privateMode.hideRecording) classes.push('rasi-hide-recording');

    BODY.classList.add('rasi-mod-active', ...classes);

    return () => {
      BODY.classList.remove(
        'rasi-mod-active',
        'rasi-blur-names',
        'rasi-blur-photos',
        'rasi-blur-last-message',
        'rasi-blur-chat-content',
        'rasi-hide-online',
        'rasi-hide-read-receipts',
        'rasi-hide-typing',
        'rasi-hide-recording',
      );
    };
  }, [privateMode]);

  useEffect(() => {
    if (!BODY) return;
    if (customBackgroundUrl) {
      BODY.style.setProperty('--rasi-chat-bg', `url("${customBackgroundUrl}")`);
      BODY.classList.add('rasi-custom-chat-bg');
    } else {
      BODY.style.removeProperty('--rasi-chat-bg');
      BODY.classList.remove('rasi-custom-chat-bg');
    }
  }, [customBackgroundUrl]);

  return null;
};

export default memo(withGlobal(
  (global): StateProps => {
    const modules = selectRasiTechModules(global);
    return {
      privateMode: modules.privateMode,
      customBackgroundUrl: modules.customizations.customChatBackgroundUrl,
    };
  },
)(RasiTechEffects));
